const excludes = [
    'agency', 'company', 'team', 'studio', 'media', 'team', 'service', 'app', 'group',
    'агентство', 'компания', 'организация', 'команда', 'студия', 'медиа',
    'агенство', 'компанія', 'організація', 'команда', 'студія', 'медіа', 'служба',
];

const notCompany = (text) => {
    text = text.trim();
    let values = text.split(' ');

    return !values.some(val => {
        val = val.toLowerCase()
        return excludes.some(excl => excl == val);
    });
}

const name = (text) => {
    let match = text.match(/^[\p{L}\s'`-]*$/gmu);
    return !!match && match.length && match.length > 0;
}

const url = (text) => {
    if (!text) return true;

    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+@]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-@]*)?'+ // query string
        '(\\#[-a-z\\d_@]*)?$','i'); // fragment locator

    let isValid = !!pattern.test( encodeURI(text) );

    return isValid;
}

export { name, notCompany, url };
